export function extractStreamId(str) {
  try {
    const url = new URL(str);
    return url.pathname.split('/')[1];
  } catch {
    return false;
  }
}
